// react and js
import { React, useContext } from "react";
import { useTranslation } from "react-i18next";

// mui
import { Box, Grid, Stack } from "@mui/material";

// components
import CardOutlet from "../../../components/CardOutlet";

// hooks
import appContext from "../../../hooks/appContext";

// i18n
import { localizeWebsiteUrl, DEFAULT_LANGUAGE } from "../../../i18n";

// layouts

// pages

// theme
import { B1Small } from "../../../theme/styled";

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function GettingStarted() {
  // eslint-disable-next-line
  const { stateStorage } = useContext(appContext);
  const { t, i18n } = useTranslation();
  const activeLang = i18n.language || DEFAULT_LANGUAGE;

  // Build the user-manual URL: /manuals/<product-tag>, with underscores
  // replaced by hyphens. Falls back to the manuals index if no plan is set.
  const productTag = stateStorage.distributionPlan
    ? stateStorage.distributionPlan.product_tag
    : null;
  const manualSlug = productTag
    ? `/manuals/${productTag.replace(/_/g, "-")}`
    : "/manuals";

  return (
    <CardOutlet
      variant="outlet"
      backgroundProp="#F2F2F2"
      title={t("distribution.gettingStarted.title")}
      subheader={t("distribution.gettingStarted.subheader")}
      mainOutlet={
        stateStorage.distributionPlan !== null ? (
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 3,
            }}
          >
            <Grid item xs={12}>
              <Stack sx={{ width: "100%" }}>
                <Box>
                  <B1Small
                    sx={{ mb: 2 }}
                    fullWidth
                    variant="contained"
                    href={localizeWebsiteUrl(
                      `${process.env.REACT_APP_URL_FRONTEND_DASHBOARD}/subscriptions`,
                      activeLang
                    )}
                    target="_blank"
                  >
                    {t("distribution.gettingStarted.manageSubscriptionButton")}
                  </B1Small>
                </Box>

                <Box>
                  <B1Small
                    fullWidth
                    variant="contained"
                    href={localizeWebsiteUrl(
                      `${process.env.REACT_APP_URL_FRONTEND_WEBSITE}${manualSlug}`,
                      activeLang
                    )}
                    target="_blank"
                  >
                    {t("distribution.gettingStarted.userManualButton")}
                  </B1Small>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        ) : null
      }
    />
  );
}
